import module from 'fan/proyecto/module.js'

export const FanProyectoColaboradoresIDSEClasesSchema = {}

export class FanProyectoColaboradoresIDSEClasesServices {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa) {
    return this.$http.get(`/kendu/empleados/configuracion/clases`, {
      params: {idEmpresa},
      schema: FanProyectoColaboradoresIDSEClasesSchema,
    })
  }
}

module.service('FanProyectoColaboradoresIDSEClases', FanProyectoColaboradoresIDSEClasesServices)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Colaboradores/IDSE/Clases.js